import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getAllTaskNames,
    getLabourTaskByOperationEntityIDTaskCategoryID,
    GetSundryFactoryManualChecklistTeaReportData,
    GetAllOperationEntityByGroupID,
    GetAvialableFieldsForDropdown,
    getJobsForDropdown,
    GetSundryManualChecklistNumbers
};

async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getJobsForDropdown() {
    var jobArray = [];
    const response = await CommonGet('/api/SundryChecklistBPLReport/GetJobsForDropdown', null)
    for (let item of Object.entries(response.data)) {
        jobArray[item[1]["taskTypeID"]] = item[1]["taskTypeName"]
    }
    return jobArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}


async function getDivisionByEstateID(operationEntityID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    let array = [];
    
    for (let item of Object.entries(response.data)) {
        const entityData = item[1];
        
        if (entityData["isActive"] === true && entityData["operationEntityID"] == operationEntityID) {
            if (entityData["operationEntityTypeID"] === 1) {
                if (entityData["collectionPointCategoryID"] === 3) {
                    array[entityData["collectionPointID"]] = entityData["collectionPointName"];
                }
            } else {
                array[entityData["collectionPointID"]] = entityData["collectionPointName"];
            }
        }
    }
    
    return array;
}

async function getAllTaskNames(groupID, estateID) {
    const response = await CommonGet('/api/EstateTask/GetEstateTaskByFilter', 'groupID=' + groupID + '&operationEntityID=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            array[item[1]["estateTaskId"]] = item[1]["estateTaskName"]
        }
    }
    return array;
}

async function getLabourTaskByOperationEntityIDTaskCategoryID(estateID, category) {
    const response = await CommonGet('/api/EmployeeTask/GetTaskDetailByOperationEntityID', 'operationEntityID=' + estateID + '&category=' + category);
    return response.data;
}

async function GetSundryFactoryManualChecklistTeaReportData(data) {
    var model = {
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        fieldID: parseInt(data.fieldID),
        SearchDate: data.searchDate,
        referenceNo: data.checklistNo == "0" ? "" : data.checklistNo,
        jobTypeID: parseInt(data.jobTypeID)
    };
    const response = await CommonPost('/api/SundryFactoryManualChecklistTeaReport/GetSundryFactoryManualChecklistTeaReportData', null, model);
    return response.data;
}

async function GetSundryManualChecklistNumbers(divisionID, jobTypeID, searchDate) {
    var fieldArray = [];
    const response = await CommonGet('/api/SundryFactoryManualChecklistTeaReport/GetSundryManualChecklistNumbers', 'divisionID=' + parseInt(divisionID) +
        '&jobTypeID=' + parseInt(jobTypeID) + '&searchDate=' + searchDate);
    for (let item of Object.entries(response.data)) {
        fieldArray[item[1]["referenceNo"]] = item[1]["referenceNo"]
    }
    return fieldArray;
}

async function GetAvialableFieldsForDropdown(divisionID) {
    var fieldArray = [];
    const response = await CommonGet('/api/SundryChecklistBPLReport/GetFieldsByDivision', 'divisionID=' + divisionID);
    for (let item of Object.entries(response.data)) {
        fieldArray[item[1]["fieldID"]] = item[1]["fieldName"]
    }
    return fieldArray;
}
